module.exports = __webpack_public_path__ + "img/n26.54022c6c.jpg";